import React, { useState, useEffect } from 'react';
import api from '../api';

function useIsMobile() {
  const [v, setV] = useState(window.innerWidth < 768);
  useEffect(() => {
    const fn = () => setV(window.innerWidth < 768);
    window.addEventListener('resize', fn);
    return () => window.removeEventListener('resize', fn);
  }, []);
  return v;
}

const PremiumStar = ({ filled }) => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill={filled ? "#d4af37" : "none"} stroke="#d4af37" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon>
  </svg>
);

const PenIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 19l7-7 3 3-7 7-3-3z"></path>
    <path d="M18 13l-1.5-7.5L2 2l3.5 14.5L13 18l5-5z"></path>
    <path d="M2 2l7.586 7.586"></path>
    <circle cx="11" cy="11" r="2"></circle>
  </svg>
);

export default function ReviewsPage() {
  const isMobile = useIsMobile();
  const [reviews, setReviews] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  
  const [rating, setRating] = useState(5);
  const [text, setText] = useState('');
  const [user, setUser] = useState(null);

  useEffect(() => {
    const storedUser = localStorage.getItem('user');
    if (storedUser) {
      try { setUser(JSON.parse(storedUser)); } catch (e) {}
    }
    fetchReviews();
  }, []);

  const fetchReviews = () => {
    setLoading(true);
    api.get('/reviews')
      .then(res => setReviews(res.data))
      .catch(err => console.log(err))
      .finally(() => setLoading(false));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!user) {
      alert('Будь ласка, увійдіть в акаунт (через кнопку в меню), щоб залишити відгук.');
      return;
    }
    if (!text.trim()) {
      alert('Будь ласка, напишіть текст відгуку.');
      return;
    }

    const author_name = user.name || user.email?.split('@')[0] || 'Гість';

    api.post('/reviews', { author_name, rating, text })
      .then(() => {
        setShowModal(false);
        setText('');
        setRating(5);
        fetchReviews(); 
      })
      .catch(err => alert('Помилка надсилання: ' + err.message));
  };

  const renderStars = (count) => {
    const stars = [];
    for (let i = 1; i <= 5; i++) {
      stars.push(<PremiumStar key={i} filled={i <= count} />);
    }
    return <div style={{ display: 'flex', gap: 2 }}>{stars}</div>;
  };

  return (
    <div className="page-enter" style={{ display: 'flex', flexDirection: 'column', height: '100%', overflowY: 'auto' }}>
      
      <div style={{
        background: '#0d0d0b', padding: isMobile ? '30px 24px' : '40px 32px',
        position: 'relative', overflow: 'hidden', flexShrink: 0,
      }}>
        <div style={{ position: 'absolute', right: -20, top: -20, width: 160, height: 160, borderRadius: '50%', border: '1px solid rgba(255,255,255,0.06)', pointerEvents: 'none' }} />

        <div style={{
          fontSize: 10, letterSpacing: '2.5px', textTransform: 'uppercase',
          color: '#c8b89a', fontWeight: 300, marginBottom: 8,
        }}>Думка гостей</div>
        
        <div style={{
          fontFamily: "'Fraunces', serif", fontSize: isMobile ? 32 : 44, fontWeight: 300,
          lineHeight: 1.1, color: '#fff',
        }}>
          Відгуки про <span style={{ 
            fontStyle: 'italic', 
            fontWeight: 600,
            background: 'linear-gradient(90deg, #F9E79F 0%, #D4AF37 50%, #F9E79F 100%)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            textShadow: '0 4px 20px rgba(212, 175, 55, 0.4)',
            display: 'inline-block',
            paddingRight: '5px' 
          }}>«Околицю»</span>
        </div>
        
        <button 
          onClick={() => user ? setShowModal(true) : alert('Будь ласка, увійдіть в акаунт (іконка чоловічка вгорі), щоб залишити відгук.')}
          style={{
            marginTop: 24, background: 'linear-gradient(135deg, #d4af37 0%, #b58d19 100%)', 
            color: '#fff', border: 'none', padding: '12px 28px', borderRadius: 30, 
            fontSize: 14, fontWeight: 600, cursor: 'pointer',
            boxShadow: '0 4px 16px rgba(212, 175, 55, 0.3)',
            transition: 'transform 0.2s, box-shadow 0.2s', display: 'inline-flex', alignItems: 'center', gap: 10
          }}
          onMouseEnter={e => { e.currentTarget.style.transform = 'translateY(-2px)'; e.currentTarget.style.boxShadow = '0 6px 20px rgba(212, 175, 55, 0.4)'; }}
          onMouseLeave={e => { e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.boxShadow = '0 4px 16px rgba(212, 175, 55, 0.3)'; }}
        >
          <PenIcon /> Написати відгук
        </button>
      </div>

      <div style={{ flex: 1, padding: isMobile ? '20px 16px' : '32px', background: '#faf8f5' }}>
        {loading ? (
          <div style={{ textAlign: 'center', color: '#6b6560', padding: '40px 0' }}>Завантаження відгуків...</div>
        ) : reviews.length === 0 ? (
          <div style={{ textAlign: 'center', color: '#6b6560', padding: '60px 0' }}>
            <div style={{ fontSize: 48, marginBottom: 16 }}>💬</div>
            <div style={{ fontSize: 18, fontWeight: 500, color: '#0d0d0b', fontFamily: "'Fraunces', serif" }}>Поки немає відгуків</div>
            <div style={{ fontSize: 14, marginTop: 6, fontWeight: 300 }}>Будьте першим, хто поділиться враженнями!</div>
          </div>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: 20, maxWidth: 800, margin: '0 auto' }}>
            {reviews.map(rev => (
              <div key={rev.id} style={{
                background: '#fff', borderRadius: 20, border: '1px solid #e8ddd0',
                padding: isMobile ? '20px' : '28px', display: 'flex', flexDirection: 'column', gap: 16,
                boxShadow: '0 8px 24px rgba(0,0,0,0.03)', position: 'relative', overflow: 'hidden'
              }}>
                <div style={{
                  position: 'absolute', top: -10, right: 20, fontSize: 100, 
                  color: 'rgba(212, 175, 55, 0.05)', fontFamily: "serif", lineHeight: 1, pointerEvents: 'none'
                }}>”</div>

                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', position: 'relative', zIndex: 1 }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                    <div style={{ 
                      width: 44, height: 44, borderRadius: '50%', background: '#fdf9ee', 
                      display: 'flex', alignItems: 'center', justifyContent: 'center', 
                      fontWeight: 600, color: '#d4af37', fontSize: 18, border: '1px solid rgba(212, 175, 55, 0.2)'
                    }}>
                      {rev.author_name.charAt(0).toUpperCase()}
                    </div>
                    <div>
                      <div style={{ fontWeight: 600, color: '#0d0d0b', fontSize: 16 }}>{rev.author_name}</div>
                      <div style={{ fontSize: 12, color: '#b5a898', marginTop: 2 }}>{new Date(rev.created_at).toLocaleDateString('uk-UA')}</div>
                    </div>
                  </div>
                  <div style={{ display: 'flex' }}>
                    {renderStars(rev.rating)}
                  </div>
                </div>
                <div style={{ color: '#4a4641', fontSize: 15, lineHeight: 1.7, fontWeight: 300, position: 'relative', zIndex: 1 }}>
                  {rev.text}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

      {showModal && (
        <div style={{
          position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.6)', backdropFilter: 'blur(4px)',
          display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 9999,
          padding: 20
        }}>
          <div style={{
            background: '#fff', width: '100%', maxWidth: 440, 
            borderRadius: 24, padding: '32px', position: 'relative',
            boxShadow: '0 20px 60px rgba(0,0,0,0.2)'
          }}>
            <button 
              onClick={() => setShowModal(false)}
              style={{ position: 'absolute', right: 20, top: 20, border: 'none', background: '#f7f4ef', width: 36, height: 36, borderRadius: '50%', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#6b6560', transition: 'background 0.2s' }}
              onMouseEnter={e => e.currentTarget.style.background = '#e8ddd0'}
              onMouseLeave={e => e.currentTarget.style.background = '#f7f4ef'}
            >✕</button>
            
            <h3 style={{ fontFamily: "'Fraunces', serif", fontSize: 26, marginBottom: 24, color: '#0d0d0b' }}>Ваш відгук</h3>
            
            <div style={{ marginBottom: 24 }}>
              <label style={{ display: 'block', fontSize: 11, color: '#8c857d', marginBottom: 8, textTransform: 'uppercase', letterSpacing: '1px', fontWeight: 600 }}>Оцінка</label>
              <div style={{ display: 'flex', gap: 8 }}>
                {[1, 2, 3, 4, 5].map(num => (
                  <button 
                    key={num} 
                    onClick={() => setRating(num)}
                    style={{ 
                      background: 'transparent', border: 'none', cursor: 'pointer', padding: 0, transition: 'transform 0.1s'
                    }}
                    onMouseEnter={e => e.currentTarget.style.transform = 'scale(1.1)'}
                    onMouseLeave={e => e.currentTarget.style.transform = 'scale(1)'}
                  >
                    <PremiumStar filled={rating >= num} />
                  </button>
                ))}
              </div>
            </div>

            <div style={{ marginBottom: 28 }}>
              <label style={{ display: 'block', fontSize: 11, color: '#8c857d', marginBottom: 8, textTransform: 'uppercase', letterSpacing: '1px', fontWeight: 600 }}>Що вам сподобалось?</label>
              <textarea 
                value={text}
                onChange={e => setText(e.target.value)}
                placeholder="Напишіть свої враження про заклад..."
                style={{
                  width: '100%', minHeight: 130, padding: '16px', borderRadius: 16,
                  border: '1px solid #e8ddd0', background: '#faf8f5',
                  fontSize: 15, color: '#0d0d0b', resize: 'vertical',
                  outline: 'none', fontFamily: 'inherit', lineHeight: 1.6,
                  transition: 'border-color 0.2s'
                }}
                onFocus={e => e.target.style.borderColor = '#d4af37'}
                onBlur={e => e.target.style.borderColor = '#e8ddd0'}
              />
            </div>

            <button 
              onClick={handleSubmit}
              style={{
                width: '100%', background: '#0d0d0b', color: '#fff', border: 'none',
                padding: '16px', borderRadius: 16, fontSize: 15, fontWeight: 500,
                cursor: 'pointer', transition: 'background 0.2s, transform 0.1s'
              }}
              onMouseEnter={e => e.currentTarget.style.background = '#2a2a2a'}
              onMouseLeave={e => e.currentTarget.style.background = '#0d0d0b'}
              onMouseDown={e => e.currentTarget.style.transform = 'scale(0.98)'}
              onMouseUp={e => e.currentTarget.style.transform = 'scale(1)'}
            >
              Опублікувати
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
